var _components;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import ItemTableViewComponent from './components/ItemTableViewComponent.vue';
import ItemTermComponent from './components/ItemTermComponent.vue';
import ItemTblDatasourceComponent from './components/ItemTblDatasourceComponent.vue';
import ItemTblDashboardComponent from './components/ItemTblDashboardComponent.vue';
import FormMetaDatasource from '@/components/tableau/FormMetaDatasource';
import FormAccessRequestDatasource from '@/components/tableau/FormAccessRequestDatasource';
import FormMetaDashboard from '@/components/tableau/FormMetaDashboard';
import FormAccessRequestWorkbook from '@/components/tableau/FormAccessRequestWorkbook';
import FormSelectTableauUser from '@/components/tableau/FormSelectTableauUser';
import FormMetadataTableComponent from '@/apps/data-platform/components/FormMetadataTableComponent.vue';
import FormAccessRequestTableComponent from '@/apps/data-platform/components/FormAccessRequestTableComponent.vue';
import search_engine_service from '@/apps/data-platform/services/search_engine_service';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import TableauUserAccessService from '@/apps/data-platform/services/visualization/tableauRol';
import FormMetaDataset from '@/modules/tasks/powerbi/components/FormMetaDataset';
import FormAccessRequestDataset from '@/modules/tasks/powerbi/components/FormAccessRequestDataset';
import FormSelectBiUser from '@/modules/tasks/powerbi/components/FormSelectBIUser.vue';
import FormMetaReportDatastudio from '@/modules/tasks/datastudio/components/FormMetaReportDatastudio';
import FormAccessRequestReportGds from '@/modules/tasks/datastudio/components/FormAccessRequestReportGDS';
import FormMetaReport from '@/modules/tasks/powerbi/components/report/FormMetaReport';
import FormAccessRequestReport from '@/modules/tasks/powerbi/components/report/FormAccessRequestReport';
import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import DialogsComponent from '@/components/DialogsComponent.vue';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import FormMetaDatasourceDatastudio from '@/modules/tasks/datastudio/components/FormMetaDatasourceDatastudio';
import FormSelectDatastudioUser from '@/modules/tasks/datastudio/components/FormSelectDatastudioUser.vue';
import FormAccessRequestDatasourceDs from '@/modules/tasks/datastudio/components/FormAccessRequestDatasourceDS';
console.log('FormAccessRequestDatasourceDS =', FormAccessRequestDatasourceDs);
import { textsDefaul, envConfig, TYPE_CHANGE_METADA, TAG_QUERIES, DEFAULT_TPL_FIELDS, ALL_TABLES_OPTION, TYPSE_SENSE_TYPE_OBJECTS, ACCESS_TYPE_FLOW, GA_EVENTS } from '@/js/constants';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import utils from '@/js/utils';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import tasks from '@/js/tasks';
import userSettingsService from '@/apps/data-platform/services/security/user_settings_service';
import userSecurityService from '@/apps/data-platform/services/security/user_security_service';
import DatastudioDatasourceService from '@/apps/data-platform/services/visualization/datastudio_datasource_service';
export default {
  name: 'PrincipalSearchPage',
  components: (_components = {
    DialogsComponent: DialogsComponent,
    FormMetadataTableComponent: FormMetadataTableComponent,
    FormAccessRequestTableComponent: FormAccessRequestTableComponent,
    ItemTableViewComponent: ItemTableViewComponent,
    ItemTermComponent: ItemTermComponent,
    ItemTblDatasourceComponent: ItemTblDatasourceComponent,
    ItemTblDashboardComponent: ItemTblDashboardComponent
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_components, "ItemTblDashboardComponent", ItemTblDashboardComponent), "FormMetaDatasource", FormMetaDatasource), "FormAccessRequestDatasource", FormAccessRequestDatasource), "FormSelectTableauUser", FormSelectTableauUser), "FormMetaDashboard", FormMetaDashboard), "FormAccessRequestWorkbook", FormAccessRequestWorkbook), "FormMetaDataset", FormMetaDataset), "FormAccessRequestDataset", FormAccessRequestDataset), "FormSelectBiUser", FormSelectBiUser), "FormMetaReport", FormMetaReport), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_components, "FormAccessRequestReport", FormAccessRequestReport), "FormMetaReportDatastudio", FormMetaReportDatastudio), "FormAccessRequestReportGds", FormAccessRequestReportGds), "OrganizacionComponent", OrganizacionComponent), "FormMetaDatasourceDatastudio", FormMetaDatasourceDatastudio), "FormSelectDatastudioUser", FormSelectDatastudioUser), "FormAccessRequestDatasourceDs", FormAccessRequestDatasourceDs)),
  computed: _objectSpread(_objectSpread(_objectSpread({
    final_table_options: function final_table_options() {
      return [{
        value: 'all',
        text: 'All'
      }, {
        value: 'yes',
        text: 'Yes'
      }, {
        value: 'no',
        text: 'No'
      }];
    },
    // Opciones de ordenamiento según los metadatos disponibles en los resultados
    sortOptions: function sortOptions() {
      return [{
        value: 'relevance',
        text: 'Relevancia (orden original)'
      }, {
        value: 'titulo',
        text: 'Nombre'
      }, {
        value: 'proyecto',
        text: 'Proyecto'
      }, {
        value: 'dataset',
        text: 'Dataset'
      }, {
        value: 'dominio',
        text: 'Dominio'
      }, {
        value: 'data_operator',
        text: 'Operador de datos'
      }, {
        value: 'numRows',
        text: 'Número de filas'
      }, {
        value: 'numColumns',
        text: 'Número de columnas'
      }, {
        value: 'numBytes',
        text: 'Tamaño'
      }];
    },
    // Resultados de la página actual ordenados por el metadato elegido.
    // 'relevance' conserva el orden del motor de búsqueda; los ítems sin el
    // metadato (ej. términos de negocio sin numRows) van siempre al final.
    sortedResults: function sortedResults() {
      var _this = this;
      var items = this.encontrado && this.encontrado.busqueda ? this.encontrado.busqueda : [];
      if (this.sortOption === 'relevance') return items;
      var key = this.sortOption;
      var numeric = ['numRows', 'numColumns', 'numBytes'].includes(key);
      var isEmpty = function isEmpty(v) {
        return v === undefined || v === null || v === '';
      };
      var withValue = items.filter(function (i) {
        return i && !isEmpty(i[key]);
      });
      var withoutValue = items.filter(function (i) {
        return !i || isEmpty(i[key]);
      });
      withValue.sort(function (a, b) {
        var result;
        if (numeric) {
          result = parseFloat(a[key]) - parseFloat(b[key]);
        } else {
          result = String(a[key]).toLowerCase().localeCompare(String(b[key]).toLowerCase());
        }
        return _this.sortDesc ? -result : result;
      });
      return withValue.concat(withoutValue);
    }
  }, mapState('data-platform', ['isTableauActive', 'isPowerBIActive', 'isDataStudioActive', 'orgs', 'filtrosbusqueda'])), mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    processd_list_domains: function processd_list_domains() {
      var list_domains = [];
      //list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : []
      //list_domains.unshift(window.userInfo.domain)
      this.orgs.forEach(function (x) {
        list_domains.unshift({
          text: x.alias,
          value: x.domain
        });
      });
      list_domains.unshift({
        text: ALL_TABLES_OPTION,
        value: ALL_TABLES_OPTION
      });
      return list_domains;
    },
    object_types: function object_types() {
      return [{
        value: TYPSE_SENSE_TYPE_OBJECTS.TABLE,
        text: this.traductor('menu.toolbar.tables')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.VIEW,
        text: this.traductor('menu.toolbar.views')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.TERM,
        text: this.traductor('menu.toolbar.business_terms')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE,
        text: this.traductor('menu.toolbar.tbl_datasources')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD,
        text: this.traductor('menu.toolbar.tbl_dashboards')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET,
        text: this.traductor('menu.toolbar.pbi_datasets')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT,
        text: this.traductor('menu.toolbar.pbi_reports')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT,
        text: this.traductor('menu.toolbar.gds_reports')
      }, {
        value: TYPSE_SENSE_TYPE_OBJECTS.GDS_DATASOURCE,
        text: this.traductor('menu.toolbar.gds_datasources')
      }];
    },
    query_by_types: function query_by_types() {
      return [{
        value: 'titulo',
        text: this.traductor('menu.query_by.title')
      },
      // { value: 'project', text: this.traductor('menu.query_by.project') },
      // { value: 'dataset', text: this.traductor('menu.query_by.dataset') },
      {
        value: 'description',
        text: this.traductor('menu.query_by.description')
      },
      // { value: 'columns', text: this.traductor('menu.query_by.columns') },
      // { value: 'definition', text: this.traductor('menu.query_by.definition') },
      // { value: 'also_known_as', text: this.traductor('menu.query_by.also_known_as') },
      // { value: 'area', text: this.traductor('menu.query_by.area') },
      // { value: 'business_definition', text: this.traductor('menu.query_by.business_definition') },
      // { value: 'data_element_name', text: this.traductor('menu.query_by.data_element_name') },
      // { value: 'data_operator', text: this.traductor('menu.query_by.data_operator') },
      // { value: 'domain', text: this.traductor('menu.query_by.domain') },
      // { value: 'official_source', text: this.traductor('menu.query_by.official_source') },
      // { value: 'org', text: this.traductor('menu.query_by.org') },
      // { value: 'subdomain', text: this.traductor('menu.query_by.subdomain') },
      // { value: 'zone', text: this.traductor('menu.query_by.zone') }
      {
        value: 'data_owner',
        text: this.traductor('menu.query_by.data_owner')
      }];
    },
    isReadonly: function isReadonly() {
      if (this.isChangeRequest === this.ACCESS_TYPE_FLOW.ACCESS) {
        return true;
      } else if (this.isChangeRequest === this.ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        return false;
      }
      return true;
    }
  }),
  data: function data() {
    return {
      all: false,
      term: false,
      table: false,
      data: false,
      book: false,
      dataset: false,
      report: false,
      report_gds: false,
      titulo: false,
      description: false,
      pillActive: '',
      existeBusqueda: false,
      encontrado: {
        'found': 0,
        'page': 1,
        'per_page': 10,
        'q': null,
        'search_time_ms': 0,
        'busqueda': [{
          id: 1,
          titulo: 'Tabla1',
          proyecto: 'proyecto',
          dataset: 'dataset',
          snippet: 'columns',
          field: 'valor',
          data_operator: 'data_operator'
        }, {
          id: 2,
          titulo: 'Tabla2',
          proyecto: 'proyecto',
          dataset: 'dataset',
          snippet: 'columns',
          field: 'valor',
          data_operator: 'data_operator'
        }]
      },
      filtro: {
        domain: null,
        object: null,
        object_comma: null,
        query_by: null,
        final_table: 'all',
        zone: null,
        data_owner: null,
        query_by_comma: null,
        q: null,
        per_page: 10,
        page: 1
      },
      MODAL_NAME: 'ListObjectsSearch',
      MODAL_NAME_METADATA_VIEW: 'ListObjectsSearchMetadataView',
      MODAL_NAME_METADATA: 'ListObjectsSearchMetadataChange',
      MODAL_NAME_LINEAGE: 'ListObjectsSearchLineage',
      objToRequest: {},
      lazyLoadParamsForViewer: null,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      key_meta: 1,
      key_view: 1,
      key_request: 1,
      TYPSE_SENSE_TYPE_OBJECTS: TYPSE_SENSE_TYPE_OBJECTS,
      filter_enabled: true,
      semanticSearch: false,
      // ordenamiento de resultados por metadatos
      sortOption: 'relevance',
      sortDesc: false,
      MODAL_DATASOURCE_METADATA_VIEW: 'modalDatasourceMetadataView',
      MODAL_DATASOURCE_METADATA_ACCESS: 'modalDatasourceMetadataAccess',
      MODAL_WORKBOOK_METADATA_VIEW: 'modalWorkbookMetadataView',
      MODAL_WORKBOOK_METADATA_ACCESS: 'modalWorkbookMetadataAccess',
      MODAL_SELECT_USER_TABLEAU: 'modalSelectUserDatasource',
      MODAL_DATASOURCE_METADATA_VIEW_GDS: 'modalDatasourceMetadataViewGDS',
      MODAL_PREVIEW_IMAGE: 'modalPreviewImage',
      currentView: {},
      currentImage: {},
      currentViewPage: 1,
      userTableau: null,
      userTableauOptions: [],
      isChangeRequest: '',
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      objDatasource: {},
      objDashboard: {},
      tableauType: '',
      MODAL_DATASET_METADATA_VIEW: 'modalDatasetMetadataView',
      MODAL_DATASET_METADATA_ACCESS: 'modalDatasetMetadataAccess',
      MODAL_REPORT_METADATA_VIEW: 'modalReportMetadataView',
      MODAL_REPORT_METADATA_ACCESS: 'modalReportMetadataAccess',
      MODAL_REPORT_METADATA_VIEW_GDS: 'modalReportMetadataViewGDS',
      MODAL_REPORT_METADATA_ACCESS_GDS: 'modalReportMetadataAccessGDS',
      MODAL_DATASOURCE_METADATA_ACCESS_GDS: 'modalDatasourceMetadataAccessGDS',
      MODAL_SELECT_USER_BI: 'modalSelectUserBIDataset',
      userBI: null,
      emailBI: null,
      userBIOptions: [],
      objDataset: {},
      objReport: {},
      biType: '',
      objReportGds: {},
      objDatasourceGds: {},
      searchs: [],
      showFinalTable: false
    };
  },
  mounted: function mounted() {},
  watch: {
    '$route': function $route() {
      this.initFromRoute();
    },
    'filtro.domain': {
      handler: function handler(newVal) {
        console.log('Domain watcher triggered with value: ', newVal);
        if (!newVal) {
          this.showFinalTable = false;
          this.filtro.final_table = 'all';
          return;
        }
        var isSomosOH = newVal.toLowerCase().includes('somosoh') || newVal.toLowerCase().includes('ifxp');
        this.showFinalTable = isSomosOH;
        console.log('Domain changed: ', newVal, ' | showFinalTable: ', this.showFinalTable);
        if (!isSomosOH) {
          this.filtro.final_table = 'all';
        }
      },
      immediate: true // Se ejecuta inmediatamente con el valor inicial
    },
    orgs: function orgs(newVal, oldVal) {
      // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
      this.buscar();
    },
    // Al elegir un metadato numérico, lo natural es ver primero los mayores
    sortOption: function sortOption(newVal) {
      this.sortDesc = ['numRows', 'numColumns', 'numBytes'].includes(newVal);
    }
  },
  created: function created() {
    var _this2 = this;
    Object.assign(this.filtro, this.filtrosbusqueda);
    console.log("created busqueda", this.filtrosbusqueda);
    console.log("enviando guardado: ", this.$router.currentRoute.params.q);
    var params_save = {
      "email": this.userInfo.email,
      "q": this.$router.currentRoute.params.q
    };
    userSettingsService.save_search(params_save).then(function (response) {
      console.log(response);
    });
    this.$bus.$on('click-pill-search', function (pill) {
      _this2.clickPillSearch(pill);
    });
    this.initFromRoute();
  },
  methods: {
    initFromRoute: function initFromRoute() {
      this.q = this.$router.currentRoute.params.q;
      this.pick_domain = this.$router.currentRoute.params.domain ? this.$router.currentRoute.params.domain : window.userInfo.domain;
      if (this.pick_domain.toUpperCase() === 'ALL') {
        this.filtro.domain = '';
      } else {
        this.filtro.domain = this.pick_domain;
      }
      this.filtro.q = this.q;
      this.all = this.$route.query.all || this.$route.query.all === 'true';
      this.table = this.$route.query.table || this.$route.query.table === 'true';
      this.term = this.$route.query.term || this.$route.query.term === 'true';
      this.data = this.$route.query.data || this.$route.query.data === 'true';
      this.book = this.$route.query.book || this.$route.query.book === 'true';
      this.dataset = this.$route.query.dataset || this.$route.query.dataset === 'true';
      this.report = this.$route.query.report || this.$route.query.report === 'true';
      this.report_gds = this.$route.query.report_gds || this.$route.query.report_gds === 'true';
      this.titulo = this.$route.query.titulo || this.$route.query.titulo === 'true';
      this.description = this.$route.query.description || this.$route.query.description === 'true';
      this.semanticSearch = this.filtrosbusqueda.semanticSearch || false;
      this.filtro.object = [];
      this.filtro.query_by = [];
      if (!this.all) {
        if (this.table) {
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.TABLE,
            text: this.traductor('menu.toolbar.tables')
          });
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.VIEW,
            text: this.traductor('menu.toolbar.views')
          });
        }
        if (this.term) {
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.TERM,
            text: this.traductor('menu.toolbar.business_terms')
          });
        }
        if (this.data) {
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE,
            text: this.traductor('menu.toolbar.tbl_datasources')
          });
        }
        if (this.book) {
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD,
            text: this.traductor('menu.toolbar.tbl_dashboards')
          });
        }
        if (this.dataset) {
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET,
            text: this.traductor('menu.toolbar.pbi_datasets')
          });
        }
        if (this.report) {
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT,
            text: this.traductor('menu.toolbar.pbi_reports')
          });
        }
        if (this.report_gds) {
          this.filtro.object.push({
            value: TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT,
            text: this.traductor('menu.toolbar.gds_reports')
          });
        }
      }
      if (this.titulo) {
        this.filtro.query_by.push({
          value: 'titulo',
          text: this.traductor('menu.query_by.title')
        });
      }
      if (this.description) {
        this.filtro.query_by.push({
          value: 'description',
          text: this.traductor('menu.query_by.description')
        });
      }
      if (this.filtro.data_owner) {
        this.filtro.query_by.push({
          value: 'data_owner',
          text: this.traductor('menu.query_by.data_owner')
        });
      }
      this.buscar();
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    getRamdonKey: function getRamdonKey() {
      return Math.round(Math.random() * 1000);
    },
    getTableReference: function getTableReference(item) {
      var tableReference = {
        datasetId: item.dataset,
        projectId: item.proyecto,
        tableId: item.titulo
      };
      return tableReference;
    },
    onVerObjeto: function onVerObjeto(item) {
      console.log('onVerObjeto', item);
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.VIEW_METADATA,
          object: item.tipo_objeto,
          domain_object: item.dominio,
          operator: this.stringToHash(item.data_operator),
          object_name: item.titulo,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      switch (item.tipo_objeto) {
        case TYPSE_SENSE_TYPE_OBJECTS.TABLE:
          this.onVerTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.VIEW:
          this.onVerTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TERM:
          this.onVerTerm(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE:
          this.openMetaDatasource(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_DATASOURCE_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD:
          this.openMetaWorkbook(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_WORKBOOK_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET:
          this.openMetaDataset(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_DATASET_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT:
          this.openMetaReport(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_REPORT_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT:
          this.openMetaReportGds(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_REPORT_METADATA_VIEW_GDS);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_DATASOURCE:
          this.openMetaDatasourceGds(item, this.ACCESS_TYPE_FLOW.VIEWER_ONLY, this.MODAL_DATASOURCE_METADATA_VIEW_GDS);
          break;
        default:
          break;
      }
    },
    onRequestObjeto: function onRequestObjeto(item) {
      console.log("revisar", item);
      if (!item.data_operator || !item.env == 'prod') {
        tasks.toast.error("Objeto no tiene data operator o no se encuentra en entorno productivo.");
        return;
      }
      switch (item.tipo_objeto) {
        case TYPSE_SENSE_TYPE_OBJECTS.TABLE:
          this.onRequestTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.VIEW:
          this.onRequestTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE:
          this.tableauType = 'datasource';
          this.openModalSelectTableauUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD:
          this.tableauType = 'workbook';
          this.openModalSelectTableauUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET:
          this.biType = 'dataset';
          this.openModalSelectBIUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT:
          this.biType = 'report';
          this.openModalSelectBIUser(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT:
          this.openMetaReportGds(item, this.ACCESS_TYPE_FLOW.ACCESS, this.MODAL_REPORT_METADATA_ACCESS_GDS);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_DATASOURCE:
          this.openMetaDatasourceGds(item, this.ACCESS_TYPE_FLOW.ACCESS, this.MODAL_DATASOURCE_METADATA_ACCESS_GDS);
          break;
        default:
          break;
      }
    },
    onChangeObjeto: function onChangeObjeto(item) {
      switch (item.tipo_objeto) {
        case TYPSE_SENSE_TYPE_OBJECTS.TABLE:
          this.onChangeTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.VIEW:
          this.onChangeTable(item);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DATASOURCE:
          this.openMetaDatasource(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_DATASOURCE_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.TBL_DASHBOARD:
          this.openMetaWorkbook(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_WORKBOOK_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_DATASET:
          this.openMetaDataset(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_DATASET_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.PBI_REPORT:
          this.openMetaReport(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_REPORT_METADATA_VIEW);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_REPORT:
          this.openMetaReportGds(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_REPORT_METADATA_VIEW_GDS);
          break;
        case TYPSE_SENSE_TYPE_OBJECTS.GDS_DATASOURCE:
          this.openMetaDatasourceGds(item, this.ACCESS_TYPE_FLOW.CHANGE_METADATA, this.MODAL_DATASOURCE_METADATA_VIEW_GDS);
          break;
        default:
          break;
      }
    },
    onVerTable: function onVerTable(item) {
      var _this3 = this;
      console.log("item:", item);
      var relativeResourceName = item.id_inca;
      var modalName = this.MODAL_NAME_METADATA_VIEW;
      var rowData = {
        relativeResourceName: relativeResourceName,
        objectId: item.proyecto + ':' + item.dataset + '.' + item.titulo,
        // 'piloto-druid-spsa:caldana.tmp_clientes_total',
        tableReference: this.getTableReference(item),
        domain_table: item.dominio,
        domain: item.dominio,
        index_node: '',
        partition: item.partition ? item.partition.field : null,
        source: item.source ? item.source : "bigquery"
      };
      var params = {
        relativeResourceName: relativeResourceName,
        pageSize: 10,
        email: window.userInfo.email,
        // index_node: rowData.index_node,
        domain_table: item.dominio,
        source: item.source ? item.source : "bigquery"
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          _this3.objToRequest = response.data;
          _this3.objToRequest.item = rowData;
          _this3.objToRequest.tipo = 'edicion';
          _this3.key_view += 1;
          _this3.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onRequestTable: function onRequestTable(item) {
      var _this4 = this;
      var relativeResourceName = item.id_inca;
      var modalName = this.MODAL_NAME;
      var rowData = {
        relativeResourceName: relativeResourceName,
        objectId: item.proyecto + ':' + item.dataset + '.' + item.titulo,
        // 'piloto-druid-spsa:caldana.tmp_clientes_total',
        tableReference: this.getTableReference(item),
        domain_table: item.dominio,
        domain: item.dominio,
        index_node: '',
        source: item.source ? item.source : "bigquery"
      };

      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: relativeResourceName,
        pageSize: 10,
        email: window.userInfo.email,
        // index_node: rowData.index_node,
        domain_table: item.dominio,
        source: item.source ? item.source : "bigquery"
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this4.objToRequest = response.data;
          _this4.objToRequest.item = rowData;
          _this4.objToRequest.tipo = 'edicion';
          // this.$bvModal.show(modalName)
          _this4.key_request += 1;
          _this4.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onChangeTable: function onChangeTable(item) {
      var _this5 = this;
      console.log(item);
      var relativeResourceName = item.id_inca;
      var modalName = this.MODAL_NAME_METADATA;
      var rowData = {
        relativeResourceName: relativeResourceName,
        objectId: item.proyecto + ':' + item.dataset + '.' + item.titulo,
        // 'piloto-druid-spsa:caldana.tmp_clientes_total',
        tableReference: this.getTableReference(item),
        domain_table: item.dominio,
        domain: item.dominio,
        index_node: '',
        source: item.source ? item.source : "bigquery"
      };

      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: relativeResourceName,
        pageSize: 10,
        email: window.userInfo.email,
        // index_node: rowData.index_node,
        domain_table: item.dominio,
        source: item.source ? item.source : "bigquery",
        projectId: item.proyecto,
        datasetId: item.dataset,
        tableId: item.titulo
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this5.objToRequest = response.data;
          _this5.objToRequest.item = rowData;
          _this5.objToRequest.tipo = 'edicion';
          // this.$bvModal.show(modalName)
          _this5.key_meta += 1;
          _this5.$refs[modalName].onOpen();
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onVerTerm: function onVerTerm(item) {
      var _this6 = this;
      userSecurityService.getDomainUser({
        email: item.data_operator
      }).then(function (response) {
        var emailDomain = response.data.domain;
        _this6.$router.push({
          path: "/BusinessTerm/".concat(emailDomain, "/").concat(item.id_inca)
        });
      });
      //const emailDomain = utils.getDomainFromEmail(item.data_operator)
    },
    openMetadataTableau: function openMetadataTableau(item, isChangeRequest, modalDatasourceMetadataView, userTableau) {
      console.log(modalDatasourceMetadataView);
      if (this.tableauType === 'datasource') {
        this.openMetaDatasource(item, isChangeRequest, modalDatasourceMetadataView, userTableau);
      } else {
        this.openMetaWorkbook(item, isChangeRequest, modalDatasourceMetadataView, userTableau);
      }
    },
    openMetaDatasource: function openMetaDatasource(item, isChangeRequest, modalDatasourceMetadataView, userTableau) {
      var _this7 = this;
      console.log(item);
      var requestData = {
        domain: item.dominio,
        page: 1,
        limit: 10,
        allDomains: false,
        searchDomain: item.dominio,
        clauses: {
          document_id: item.id_inca
        },
        filters: []
      };
      TableauDatasourceService.tableauDataSourceQueryAllDomain(requestData).then(function (res) {
        if (res.code === 200 && res.success) {
          var obj = res.data.result;
          obj.domain = item.dominio;
          _this7.userTableau = userTableau;
          _this7.isChangeRequest = isChangeRequest;
          _this7.objDatasource = obj;
          _this7.$refs[modalDatasourceMetadataView].onOpen();
        }
      });
    },
    openMetaWorkbook: function openMetaWorkbook(item, isChangeRequest, modalWorkbookMetadataView, userTableau) {
      var _this8 = this;
      var requestData = {
        domain: item.dominio,
        page: 1,
        limit: 10,
        allDomains: false,
        searchDomain: item.dominio,
        clauses: {
          document_id: item.id_inca
        },
        filters: []
      };
      TableauDashboardService.tableauWorkBookQueryAllDomain(requestData).then(function (res) {
        if (res.code === 200 && res.success) {
          var obj = res.data.result;
          obj.domain = item.dominio;
          _this8.userTableau = userTableau;
          _this8.isChangeRequest = isChangeRequest;
          _this8.objDashboard = obj;
          _this8.$refs[modalWorkbookMetadataView].onOpen();
        }
      });
    },
    openModalSelectTableauUser: function openModalSelectTableauUser(item) {
      var _this9 = this;
      var requestData = {
        domain: item.dominio,
        page: 1,
        limit: 10,
        allDomains: false,
        searchDomain: item.dominio,
        clauses: {
          document_id: item.id_inca
        },
        filters: []
      };
      if (this.tableauType == 'datasource') {
        TableauDatasourceService.tableauDataSourceQueryAllDomain(requestData).then(function (res) {
          if (res.code === 200 && res.success) {
            var obj = res.data.result;
            obj.domain = item.dominio;
            _this9.objDatasource = obj;
            _this9.userTableau = null;
            TableauUserAccessService.getUserTableauByEmail().then(function (response) {
              _this9.userTableauOptions = [{
                value: null,
                text: 'Please select an user'
              }].concat(response.data);
              _this9.$refs[_this9.MODAL_SELECT_USER_TABLEAU].onOpen();
            });
          }
        });
      } else {
        TableauDashboardService.tableauWorkBookQueryAllDomain(requestData).then(function (res) {
          if (res.code === 200 && res.success) {
            var obj = res.data.result;
            obj.domain = item.dominio;
            _this9.objDashboard = obj;
            _this9.userTableau = null;
            TableauUserAccessService.getUserTableauByEmail().then(function (response) {
              _this9.userTableauOptions = [{
                value: null,
                text: 'Please select an user'
              }].concat(response.data);
              _this9.$refs[_this9.MODAL_SELECT_USER_TABLEAU].onOpen();
            });
          }
        });
      }
    },
    openMetaDataset: function openMetaDataset(item, isChangeRequest, modalDatasetMetadataView, userBI, emailBI) {
      var _this0 = this;
      var params = {
        dataset_id: item.id_inca
      };
      BiDatasetService.getDatasetById(params).then(function (res) {
        _this0.userBI = userBI;
        _this0.emailBI = emailBI;
        _this0.isChangeRequest = isChangeRequest;
        _this0.objDataset = res.data;
        _this0.objDataset.domain = item.dominio;
        _this0.$refs[modalDatasetMetadataView].onOpen();
      });
    },
    openMetaDatasourceGds: function openMetaDatasourceGds(item, isChangeRequest, modalDatasourceMetadataView) {
      var _this1 = this;
      console.log('openMetaDatasourceGds: ', item);
      console.log('isChangeRequest: ', isChangeRequest);
      console.log('modalDatasourceMetadataView: ', modalDatasourceMetadataView);
      var params = {
        datasource_id: item.id_inca
      };
      DatastudioDatasourceService.getDatasourceById(params).then(function (res) {
        _this1.isChangeRequest = isChangeRequest;
        _this1.objDatasourceGds = res.data;
        _this1.$set(_this1.objDatasourceGds, 'terminos_negocio', res.data.business_terms.map(function (bt) {
          return bt;
        }) || []);
        _this1.$set(_this1.objDatasourceGds, 'business_terms', res.data.business_terms.map(function (bt) {
          return bt;
        }) || []);
        console.log('objDatasourceGds: ', _this1.objDatasourceGds);
        _this1.objDatasourceGds.domain = item.dominio;
        _this1.$refs[modalDatasourceMetadataView].onOpen();
      });
    },
    openModalSelectDatastudioUser: function openModalSelectDatastudioUser(item) {
      var _this10 = this;
      var params = {
        dataset_id: item.id_inca
      };
      DatastudioDatasourceService.getDatasourceById(params).then(function (res) {
        _this10.objDataset = res.data;
        _this10.objDataset.domain = item.dominio;
        _this10.userBI = null;
        BiUserAccessService.getUserbiByEmail().then(function (response) {
          response.data.push({
            text: window.userInfo.email,
            value: window.userInfo.email
          });
          _this10.userBIOptions = [{
            value: null,
            text: 'Please select an user'
          }].concat(response.data);
          _this10.$refs[_this10.MODAL_SELECT_USER_BI].onOpen();
        });
      });
    },
    openMetaReport: function openMetaReport(item, isChangeRequest, modalReportMetadataView, userBI, emailBI) {
      var _this11 = this;
      var params = {
        report_id: item.id_inca
      };
      BiReportService.getReportById(params).then(function (res) {
        _this11.userBI = userBI;
        _this11.emailBI = emailBI;
        _this11.isChangeRequest = isChangeRequest;
        _this11.objReport = res.data;
        _this11.objReport.domain = item.dominio;
        _this11.$refs[modalReportMetadataView].onOpen();
      });
    },
    openModalSelectBIUser: function openModalSelectBIUser(item) {
      var _this12 = this;
      if (this.biType == 'dataset') {
        var params = {
          dataset_id: item.id_inca
        };
        BiDatasetService.getDatasetById(params).then(function (res) {
          _this12.objDataset = res.data;
          _this12.objDataset.domain = item.dominio;
          _this12.userBI = null;
          BiUserAccessService.getUserbiByEmail().then(function (response) {
            response.data.push({
              text: window.userInfo.email,
              value: window.userInfo.email
            });
            _this12.userBIOptions = [{
              value: null,
              text: 'Please select an user'
            }].concat(response.data);
            _this12.$refs[_this12.MODAL_SELECT_USER_BI].onOpen();
          });
        });
      } else {
        var _params = {
          report_id: item.id_inca
        };
        BiReportService.getReportById(_params).then(function (res) {
          _this12.objReport = res.data;
          _this12.objReport.domain = item.dominio;
          _this12.userBI = null;
          BiUserAccessService.getUserbiByEmail().then(function (response) {
            response.data.push({
              text: window.userInfo.email,
              value: window.userInfo.email
            });
            _this12.userBIOptions = [{
              value: null,
              text: 'Please select an user'
            }].concat(response.data);
            _this12.$refs[_this12.MODAL_SELECT_USER_BI].onOpen();
          });
        });
      }
    },
    openMetaReportGds: function openMetaReportGds(item, type, modalName) {
      var _this13 = this;
      var params = {
        report_id: item.id_inca
      };
      DatastudioReportService.getReportById(params).then(function (res) {
        _this13.userBI = window.userInfo.email;
        _this13.isChangeRequest = type;
        _this13.objReportGds = res.data;
        _this13.$refs[modalName].onOpen();
      });
    },
    clickPillSearch: function clickPillSearch(pill) {
      this.buscar();
      console.log(pill, pill ? pill.name : '');
      var pillActive = pill ? pill.name : '';
      if (pillActive === 'all') {
        this.pillActive = 'table';
      } else {
        this.pillActive = pillActive;
      }
    },
    onLimpiar: function onLimpiar() {
      this.filtro.q = '';
      this.filtro.domain = '';
      this.filtro.data_owner = null;
      this.filtro.zone = null;
      this.filtro.final_table = 'all';
      this.filtro.page = 1;
      this.buscar();
    },
    buscar: function buscar() {
      var _this14 = this;
      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.filtro.domain == null) {
        this.filtro.domain = '';
      } else if (this.filtro.domain === 'All') {
        this.filtro.domain = '';
      }
      if (this.filtro.object == null) {
        this.filtro.object = '';
      }
      var objetos = [];
      for (var _i = 0, _Object$entries = Object.entries(this.filtro.object); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        objetos.push(value.value);
      }
      this.filtro.object_comma = objetos.join(',');
      if (this.filtro.query_by == null) {
        this.filtro.query_by = '';
      }
      var query_by = [];
      for (var _i2 = 0, _Object$entries2 = Object.entries(this.filtro.query_by); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _key = _Object$entries2$_i[0],
          _value = _Object$entries2$_i[1];
        query_by.push(_value.value);
      }
      this.filtro.query_by_comma = query_by.join(',');
      if (first) {
        this.filtro.page = 1;
      }
      var params = Object.assign({}, this.filtro);
      params.final_table = this.filtro.final_table;
      params.data_owner = this.filtro.data_owner;
      params.zone = this.filtro.zone;
      if (params.domain.toUpperCase() === '') {
        var domains = "";
        if (this.orgs && this.orgs.length == 0) {
          domains = 'All,' + window.userInfo.domain;
        } else {
          this.processd_list_domains.forEach(function (x) {
            if (domains != '') domains += ',';
            domains += x.value;
          });
        }
        params.domain = domains;
      }
      this.$store.dispatch('data-platform/guardarfiltrosbusqueda', _objectSpread(_objectSpread({}, this.filtrosbusqueda), {}, {
        semanticSearch: this.semanticSearch
      }));
      tasks.lockScreen.lock();
      var searchCall = this.semanticSearch ? search_engine_service.getVectorSearch(params) : search_engine_service.getBuscador(params);
      searchCall.then(function (response) {
        tasks.lockScreen.unlock();
        _this14.encontrado = response;
        console.log("asd:", _this14.encontrado);
        _this14.existeBusqueda = _this14.encontrado.found > 0;
      }, function (err) {
        tasks.lockScreen.unlock();
      }).then(function () {
        var tables_send = [];
        var views_send = [];
        var test = _this14.encontrado.busqueda;
        if (!test) return;
        var tables = test.filter(function (table) {
          return table.tipo_objeto == "table";
        });
        var views = test.filter(function (view) {
          return view.tipo_objeto == "view";
        });
        console.log("vistas", views);
        if (views.length > 0) {
          console.log("vista enviada");
          views.forEach(function (item) {
            views_send.push({
              projectId: item.proyecto,
              datasetId: item.dataset,
              tableId: item.titulo,
              domain_table: item.dominio,
              is_view: true,
              source: item.source ? item.source : "bigquery"
            });
          });
          var _params2 = {
            'tables': views_send
          };
          console.log(_params2);
          assignments_service.getTablesDetails(_params2).then(function (response) {
            var views_metadata = response.data;
            console.log("vistas_metadata: ", views_metadata);
            views = views.map(function (item) {
              var temp = Object.assign({}, item);
              var view = temp;
              var id = view.proyecto + ":" + view.dataset + "." + view.titulo;
              var bytes = views_metadata[id].numBytes || '0';
              var numRows = views_metadata[id].numRows || '0';
              var numColumns = views_metadata[id].schema.fields ? views_metadata[id].schema.fields.length : '0';
              temp.numColumns = numColumns;
              temp.numBytes = bytes;
              temp.numRows = numRows;
              // Métricas de uso (contrato: objeto completo o null)
              temp.query_stats = views_metadata[id].query_stats || null;
              var partition = views_metadata[id].timePartitioning;
              console.log("partition:", partition);
              if (partition) {
                console.log("done");
                temp.partition = partition;
              }
              return temp;
            });
            _this14.encontrado.busqueda = _this14.encontrado.busqueda.map(function (obj) {
              return views.find(function (o) {
                return o.titulo === obj.titulo && o.dataset === obj.dataset && o.proyecto === obj.proyecto;
              }) || obj;
            });
          });
        }
        if (tables.length > 0) {
          tables.forEach(function (item) {
            tables_send.push({
              projectId: item.proyecto,
              datasetId: item.dataset,
              tableId: item.titulo,
              domain_table: item.dominio,
              source: item.source ? item.source : "bigquery"
            });
          });
          var _params3 = {
            'tables': tables_send
          };
          assignments_service.getTablesDetails(_params3).then(function (response) {
            var tables_metadata = response.data;
            tables = tables.map(function (item) {
              var temp = Object.assign({}, item);
              var table = temp;
              var id = table.proyecto + ":" + table.dataset + "." + table.titulo;
              var bytes = tables_metadata[id].numBytes || '0';
              var numRows = tables_metadata[id].numRows || '0';
              var numColumns = tables_metadata[id].schema.fields ? tables_metadata[id].schema.fields.length : '0';
              temp.numColumns = numColumns;
              temp.numBytes = bytes;
              temp.numRows = numRows;
              // Métricas de uso (contrato: objeto completo o null)
              temp.query_stats = tables_metadata[id].query_stats || null;
              var partition = tables_metadata[id].timePartitioning;
              console.log("partition:", partition);
              if (partition) {
                console.log("done");
                temp.partition = partition;
              }
              return temp;
            });
            _this14.encontrado.busqueda = _this14.encontrado.busqueda.map(function (obj) {
              return tables.find(function (o) {
                return o.titulo === obj.titulo && o.dataset === obj.dataset && o.proyecto === obj.proyecto;
              }) || obj;
            });
          });
        }
      });
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    next: function next(page) {
      this.filtro.page = page;
      this.buscar();
    }
  }
};